<template>
    <div class="banner v2">
        <img src="../../@core/pic/banner.png" alt="">
        <div class="lay">
            <div class="breadcrumb">
                <div class="container">
                    <span class="crumb-item">
			            <router-link to="/">
                            <i class="fs-20" data-feather="home"></i>
                            {{$t('gen.home')}}
                        </router-link>
                    </span>
                    <span class="crumb-item">
                        <a href="#">
                            {{title}}
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            bannerImg: ''
        }
    },
    props:{
        title:{
            required: true
        }
    },
    mounted() {
        this.bannerImg = this.$store.state.home.appInfo.page_banner;
    },
}
</script>
